import React, { useState } from "react";
import { Paper, Group, Text, ActionIcon, Stack, Button } from "@mantine/core";
import { IconCheck, IconCopy } from "@tabler/icons-react";
import { CopyButton } from "@mantine/core";
import { observer } from "mobx-react";
import { Cubby } from "../../stores/Cubby";

const NostrPrivateKeyDisplay = observer(({ cubby }: { cubby: Cubby }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleRevealKey = () => {
    setIsLoading(true);
    try {
      // Trigger the action to reveal the key
      cubby.cubbyFastInfo("reveal_nostr_private_key");
    } catch (error) {
      console.error("Error revealing key:", error);
    }
  };

  return (
    <Paper p="md" withBorder radius="md" style={{ position: "relative" }}>
      <Group pr="sm" justify="flex-start" gap="s">
        <Stack gap="xs">
          {!cubby.nostrPrivateKey && (
            <Button
              loading={isLoading}
              onClick={() => handleRevealKey()}
              variant="default"
            >
              Reveal Nostr Private Key
            </Button>
          )}
          {cubby.nostrPrivateKey && (
            <Group
              gap="xs"
              align="center"
              style={{ justifyContent: "space-between" }}
            >
              <Text size="xs" style={{ wordBreak: "break-all", flex: 1 }}>
                {cubby.nostrPrivateKey}
              </Text>
              <CopyButton value={cubby.nostrPrivateKey}>
                {({ copied, copy }) => (
                  <ActionIcon
                    size="lg"
                    variant={copied ? "filled" : "default"}
                    color={copied ? "teal" : "blue"}
                    onClick={copy}
                    aria-label="copy address"
                  >
                    {copied ? <IconCheck /> : <IconCopy />}
                  </ActionIcon>
                )}
              </CopyButton>
            </Group>
          )}

          {cubby.nostrPrivateKey && (
            <Text
              size="xs"
              mt="-.5rem"
              c="dimmed" // Make the text dimmed
            >
              nostr private key, be careful with this
            </Text>
          )}
        </Stack>
      </Group>
    </Paper>
  );
});

export default NostrPrivateKeyDisplay;
